export const PanelFooter = () => {
  return (
    <div className="flex justify-between items-center w-full mt-2">
      <div className="flex justify-between items-center flex-1">
        <span className="text-xs text-gray-400">Updated: {new Date().toLocaleTimeString()}</span>
        <a
          href="https://www.antirugagent.com/glossary"
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-blue-400 hover:text-purple-400 transition-colors"
        >
          Don't understand some words? We got you
        </a>
      </div>
    </div>
  );
};
